import React from "react";

import ttImage from "../../assets/images/tt.png";
import disImage from "../../assets/images/dis.png";
import capImage from "../../assets/images/cap.png";
import tttImage from "../../assets/images/ttt.png";
import bepcImage from "../../assets/images/bepc.png";
import baccImage from "../../assets/images/bacc.png";
import probImage from "../../assets/images/prob.png";
import alImage from "../../assets/images/gcea-tve.png";
import ttnewImage from "../../assets/images/tt-new.png";
import gceoImage from "../../assets/images/gceo-tve.png";

interface HeaderSectionProps {
  examTypes: Array<{ id: number; name: string }>;
  selectedExamTypes: Array<{ id: number; name: string }>;
}

const HeaderSection: React.FC<HeaderSectionProps> = ({
  examTypes,
  selectedExamTypes,
}) => {
  const hasExamType = (name: string, exact = false) =>
    selectedExamTypes.some((et) =>
      exact ? et.name === name : et.name.includes(name)
    );

  const examLogo = hasExamType("TT NEW", true)
    ? ttnewImage
    : hasExamType("TTT", true)
      ? tttImage
      : hasExamType("TT", true)
        ? ttImage
        : hasExamType("GCE O/L")
          ? gceoImage
          : hasExamType("GCE A/L") || hasExamType("TVE A/L")
            ? alImage
            : hasExamType("TVE I/L")
              ? gceoImage // Assuming TVE I/L uses same logo as O/L based on original code logic which seemed to default to O/L or check for it? Original logic for TVE I/L checked specific exam type name.
              : hasExamType("BACC")
                ? baccImage
                : hasExamType("BEPC")
                  ? bepcImage
                  : hasExamType("PROB")
                    ? probImage
                    : hasExamType("CAP")
                      ? capImage
                      : hasExamType("DIS")
                        ? disImage
                        : gceoImage;

  return (
    <div className="gceo-header" style={{ position: "relative" }}>
      <img
        src={examLogo}
        alt="Exam Logo"
        style={{
          position: "absolute",
          left: 0,
          top: selectedExamTypes.includes(
            examTypes.find((et) => et.name.includes("CAP"))!
          )
            ? "85%"
            : "75%",
          transform: "translateY(-50%)",
          maxHeight: "40px",
        }}
      />
      <div className="gceo-header-left">
        <p className="gceo-header-text bold">REPUBLIQUE DU CAMEROUN</p>
        <p className="gceo-header-text italic">Paix-Travail-Patrie</p>
        <p className="gceo-header-text bold">-------------</p>
        <p className="gceo-header-text bold">
          MINISTERE DES ENSEIGNEMENTS SECONDAIRES
        </p>
        <p className="gceo-header-text bold">-------------</p>
        <p className="gceo-header-text bold">
          CELLULE D'APPUI A L'ACTION PEDAGOGIQUE
        </p>
        <p className="gceo-header-text bold small">EXTERNE EDUCATION SECTION</p>
        <p className="gceo-header-text bold">-------------</p>
        <p className="gceo-header-text bold small">BP 2183 MANKON BAMENDA</p>
        <p className="gceo-header-text bold small">TEL: 233 362 209</p>
        <p className="gceo-header-text small">Email: trubamenda@yahoo.co.uk</p>
      </div>

      <div className="gceo-header-center">
        <img
          src="/images/tru-logo.jpeg"
          alt="TRU Logo"
          style={{ height: "95px", width: "140px" }}
        />
      </div>

      <div className="gceo-header-right">
        <p className="gceo-header-text bold">REPUBLIC OF CAMEROON</p>
        <p className="gceo-header-text italic">Peace-Work-Fatherland</p>
        <p className="gceo-header-text bold">-------------</p>
        <p className="gceo-header-text bold">MINISTRY OF SECONDARY EDUCATION</p>
        <p className="gceo-header-text bold">-------------</p>
        <p className="gceo-header-text bold">TEACHERS' RESOURCE UNIT</p>
        <p className="gceo-header-text bold small">
          REGIONAL BRANCH FOR THE NORTH WEST
        </p>
        <p className="gceo-header-text bold">-------------</p>
        <p className="gceo-header-text bold small">
          P.O. BOX: 2183 MANKON BAMENDA
        </p>
        <p className="gceo-header-text bold small">TEL: 233 362 209</p>
        <p className="gceo-header-text small">Email: trubamenda@yahoo.co.uk</p>
      </div>
    </div>
  );
};

export default HeaderSection;
